// extracted by mini-css-extract-plugin
export default {"container":"LAeEP","arrow":"sGjqV","page":"_1SX8Y","active":"_3VU4N"};